import { Context, Data } from 'effect';
export class AuthoringError extends Data.TaggedError('@fixtuur/backpack/ConfigurationTemplatesAuthoringService/AuthoringError') {
}
export class ConfigurationTemplatesAuthoringService extends Context.Tag('@fixtuur/backpack/ConfigurationTemplatesAuthoringService')() {
}
